import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f6485a6")

_pushScopeId("data-v-6f6485a6")
const _hoisted_1 = {
  key: 0,
  class: "event-ranking-container"
}
const _hoisted_2 = { class: "event-ranking-key-visual" }
const _hoisted_3 = {
  key: 1,
  class: "end-label"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "end-label-text" }, "終了しました", -1)
const _hoisted_5 = { class: "event-ranking-main-top-section" }
const _hoisted_6 = {
  key: 0,
  class: "event-ranking-caption"
}
const _hoisted_7 = {
  key: 1,
  class: "event-ranking-detail"
}
const _hoisted_8 = {
  class: "photograph-btn",
  href: "#benefits"
}
const _hoisted_9 = { class: "btn-content" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("特典をチェック")
const _hoisted_11 = { class: "event-ranking-body-section" }
const _hoisted_12 = { class: "ranking-section" }
const _hoisted_13 = {
  class: "benefits-bg",
  id: "benefits"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("h1", { class: "benefits-heading" }, "ランキング特典", -1)
const _hoisted_15 = { class: "benefits-contents" }
const _hoisted_16 = { class: "benefits-content-box" }
const _hoisted_17 = { class: "benefits-content" }
const _hoisted_18 = { class: "benefits-note" }
const _hoisted_19 = {
  key: 0,
  class: "entry-benefits-container"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("h1", { class: "entry-benefits-heading" }, "エントリー特典", -1)
const _hoisted_21 = { class: "entry-benefits-content" }
const _hoisted_22 = {
  key: 0,
  class: "notes-section-container"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("h1", { class: "notes-top-title" }, "注意事項", -1)
const _hoisted_24 = { class: "notes-contents" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_Ranking = _resolveComponent("Ranking")

  return (_ctx.event != undefined)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.event.keyVisualImageUri != undefined)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "event-ranking-key-visual-image",
                src: _ctx.event.keyVisualImageUri
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.event.endDate < new Date())
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.event.caption != undefined)
            ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.event.caption), 1))
            : _createCommentVNode("", true),
          (_ctx.event.detail != undefined)
            ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.event.detail), 1))
            : _createCommentVNode("", true),
          (_ctx.event.benefitsImageUri != undefined)
            ? (_openBlock(), _createBlock("img", {
                key: 2,
                class: "photograph-circle-img",
                src: _ctx.event.benefitsImageUri
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("a", _hoisted_8, [
            _createVNode("p", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_font_awesome_icon, {
                class: "chevron-icon",
                icon: "chevron-down"
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Ranking, {
              event: _ctx.event,
              rankingUsers: _ctx.rankingUsers
            }, null, 8, ["event", "rankingUsers"])
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("ul", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.event.benefitsByRank, (benefits) => {
                return (_openBlock(), _createBlock("li", null, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("img", {
                      class: "benefits-target-img",
                      src: benefits.targetImageUri
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_17, _toDisplayString(benefits.content), 1),
                    _createVNode("p", _hoisted_18, _toDisplayString(benefits.note), 1),
                    _createVNode("img", {
                      class: "benefits-img",
                      src: benefits.imageUri
                    }, null, 8, ["src"])
                  ])
                ]))
              }), 256))
            ]),
            (_ctx.event.entryBenefits != undefined)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.event.entryBenefits), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.event.caution != undefined)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("p", _hoisted_24, _toDisplayString(_ctx.event.caution), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})